<template>
  <button
    type="button"
    class="calculation-toggle"
    :class="{active: value, busy}"
    role="switch"
    :aria-checked="value ? 'true' : 'false'"
    :aria-label="value ? 'Vyradiť z výpočtu' : 'Zahrnúť do výpočtu'"
    :disabled="disabled || busy"
    @click="$emit('change', !value)"
  >
    <span class="calculation-toggle-copy">
      <span class="calculation-toggle-label">
        {{ value ? "Vo výpočte" : "Mimo výpočtu" }}
      </span>
      <span class="calculation-toggle-note">
        {{ value ? "Započítava sa do limitov" : "Položka zostáva iba evidovaná" }}
      </span>
    </span>
    <span class="calculation-toggle-track" aria-hidden="true">
      <span class="calculation-toggle-knob"></span>
    </span>
  </button>
</template>

<script>
export default {
  name: "CalculationToggle",
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    busy: Boolean,
    disabled: Boolean,
  },
};
</script>

<style scoped lang="scss">
.calculation-toggle {
  display: flex;
  width: 100%;
  min-width: 0;
  padding: 10px 12px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid var(--app-border);
  border-radius: 12px;
  background: var(--app-surface-muted);
  color: var(--app-text);
  text-align: left;
  cursor: pointer;
  transition: border-color .18s ease, background-color .18s ease, opacity .18s ease;
}

.calculation-toggle:hover:not(:disabled),
.calculation-toggle:focus-visible {
  border-color: var(--app-primary);
}

.calculation-toggle:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--app-primary) 42%, transparent);
  outline-offset: 2px;
}

.calculation-toggle:disabled {
  cursor: wait;
  opacity: .72;
}

.calculation-toggle-copy {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.calculation-toggle-label {
  color: var(--app-text);
  font-size: 13px;
  font-weight: 800;
  line-height: 1.2;
}

.calculation-toggle-note {
  color: var(--app-text-muted);
  font-size: 11px;
  font-weight: 500;
  line-height: 1.3;
}

.calculation-toggle-track {
  position: relative;
  flex: 0 0 44px;
  width: 44px;
  height: 24px;
  border: 1px solid var(--app-border);
  border-radius: 999px;
  background: color-mix(in srgb, var(--app-text-muted) 30%, transparent);
  transition: border-color .18s ease, background-color .18s ease;
}

.calculation-toggle-knob {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .24);
  transition: transform .18s ease;
}

.calculation-toggle.active .calculation-toggle-track {
  border-color: var(--app-primary);
  background: var(--app-primary);
}

.calculation-toggle.active .calculation-toggle-knob {
  transform: translateX(20px);
}

.calculation-toggle.busy .calculation-toggle-knob {
  animation: toggle-pulse .8s ease-in-out infinite alternate;
}

@keyframes toggle-pulse {
  to { opacity: .45; }
}
</style>
